
<div>Start {{clickedEvent.start}}</div>

<p-button label="Delete" type="button"   (click)= deleteSchedule() styleClass="p-button" class="pngRedBtn"></p-button>
